<script>
    import { findings } from "../../routes/finding/findings.state.svelte.js";
    let {
        value,
        rowIndex,
        rowId,
        instructKey
    } = $props();

    let data = $derived(value);
</script>
<style>

</style>
{#if data}
    {#if !findings.list.loading}
        <a href='{`${data.path}/${data["id"]}`}' title={data.title}>{data.label + (data.vul_id ? (data.vul_id.includes("CVE") && !data.label.includes("CVE") ? ` (${data.vul_id})` : "") : "")}</a>
    {:else}
        <div><i class="fas fa-sync-alt fa-spin"></i></div>
    {/if}
{/if}
{#if findings.list.loading}
    <div><i class="fas fa-sync-alt fa-spin"></i></div>
{/if}
